import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SystemAccess } from '@system-dyg/shared/models';
import { UiAvatarComponent } from '../../atoms/avatar/avatar.component';
import {
  UiProfileMenuBuiltInIcon,
  UiProfileMenuItem,
  UI_PROFILE_MENU_DEFAULT_ITEMS,
} from '../user-profile-menu/user-profile-menu.types';

export type { UiProfileMenuItem, UiProfileMenuBuiltInIcon };

/**
 * Molécula: panel lateral del welcome panel.
 * Variante de `ui-user-profile-menu` adaptada para la pantalla de bienvenida:
 * - Saludo personalizado en lugar de título genérico.
 * - Sin botón "Cerrar sesión".
 * - Sección de accesos a los sistemas del usuario.
 */
@Component({
  selector: 'ui-welcome-user-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAvatarComponent],
  templateUrl: './welcome-user-panel.component.html',
  styleUrl: './welcome-user-panel.component.scss',
  host: { class: 'ui-welcome-user-panel-host' },
})
export class UiWelcomeUserPanelComponent {
  readonly userName = input.required<string>();
  readonly userRole = input('');
  readonly userEmail = input('');

  readonly avatarSrc = input<string | null>(null);
  readonly avatarLabel = input<string | null>(null);
  readonly avatarIconSrc = input<string | null>(null);
  readonly avatarAlt = input('');

  readonly items = input<readonly UiProfileMenuItem[]>(UI_PROFILE_MENU_DEFAULT_ITEMS);
  readonly systems = input<readonly SystemAccess[]>([]);

  readonly itemSelect = output<{ id: string }>();
  readonly systemSelect = output<SystemAccess>();

  protected resolveIcon(item: UiProfileMenuItem): UiProfileMenuBuiltInIcon {
    return item.icon ?? 'user';
  }

  protected onItemClick(id: string): void {
    this.itemSelect.emit({ id });
  }

  protected onSystemClick(system: SystemAccess): void {
    this.systemSelect.emit(system);
  }
}
